module.exports = __webpack_public_path__ + "img/4.de46d998.jpg";